import React from 'react';
import { Alert, Button } from '@shared/components';
import { useChooseAnotherProduct } from '../hooks/useChooseAnotherProduct';

export const NoSellingDealerError: React.FC = () => {
    const { message, action } = useChooseAnotherProduct();
    const messageId = `${React.useId()}-block-reason`;

    return (
        <Alert variant="error" role="alert" className="flex-col items-start">
            <p className="font-semibold">No dealer you can sell for offers this product</p>
            {message && (
                <p id={messageId} className="text-sm">
                    {message}
                </p>
            )}
            {action && (
                <Button
                    type="button"
                    variant="primary"
                    onClick={action.onClick}
                    ariaDescribedBy={message ? messageId : undefined}
                >
                    {action.label}
                </Button>
            )}
        </Alert>
    );
};
